// import React from 'react';
import { initializeIcons } from '@fluentui/react';

initializeIcons('https://static2.sharepointonline.com/files/fabric/assets/icons/');